import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { TERMINOLOGY_MAP, TerminologyProfile, IndustryProfileCode } from '../config/terminologyMap';

const LABEL_TO_CODE: Record<string, IndustryProfileCode> = {
  'Financial Services': 'FS',
  'Technology / SaaS': 'TECH',
  'Healthcare': 'HEALTH',
  'Construction / Manufacturing': 'CONST',
  'Generic / Internal': 'GEN',
  'General / Other': 'GEN',
};

function resolveIndustryCode(raw: string | undefined): IndustryProfileCode {
  if (!raw) return 'GEN';
  const upper = raw.toUpperCase() as IndustryProfileCode;
  if (TERMINOLOGY_MAP[upper]) return upper;
  return LABEL_TO_CODE[raw] || 'GEN';
}

export function useTerminology(): TerminologyProfile {
  const { user } = useAuth();

  return useMemo(() => {
    const code = resolveIndustryCode(user?.industryProfile);
    return TERMINOLOGY_MAP[code];
  }, [user?.industryProfile]);
}

/** For use outside React components (e.g., utility functions) */
export function getTerminology(profileCode: string): TerminologyProfile {
  const code = resolveIndustryCode(profileCode);
  return TERMINOLOGY_MAP[code];
}
